import { PersonIdentTyp } from 'fobclient/lib/entity'

import FieldsGeneric from './FieldsGeneric'
let Fields = FieldsGeneric('PersonIdentTyp')

export default {
  label: 'PersonIdentTyp',
  route: 'personIdentTyp',
  class: PersonIdentTyp,
  className: 'personIdentTyp',
  fields: [
    {
      ...Fields.String('kennung'),
      table: true
    },
    Fields.String('anmerkung')
  ]
}



// WEBPACK FOOTER //
// ./src/schema/PersonIdentTyp.js